import { App } from "App";
import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { TenantProvider } from "store/contextTenant";

import { persistor, store } from "store";

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement
);

root.render(
	<React.StrictMode>
		<Provider store={store}>
			<TenantProvider>
				<HelmetProvider>
					<PersistGate loading={null} persistor={persistor}>
						<App />
					</PersistGate>
				</HelmetProvider>
			</TenantProvider>
		</Provider>
	</React.StrictMode>
);
